////////////////////////////////////////////////////////////////////////////////////////////////////
//
// The DateTimeFunc class 
// @version 0.0.1.0
// @created-date 2014.06.12
// @modified-date 2014.06.12
// @author beach.li
//
////////////////////////////////////////////////////////////////////////////////////////////////////
//--------------------------------------------------
// package.class id
//--------------------------------------------------
// "tbs.util.DateTimeFunc",

//--------------------------------------------------
// imported classes
//--------------------------------------------------
//--------------------------------------------------
// construtor
//--------------------------------------------------
var tbs_util_DateTimeFunc = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_util_DateTimeFunc.prototype = {
	//--------------------------------------------------
	// static api
	//--------------------------------------------------
    /**
      * Format utc time
      */
    formatUTCTime: function(value, format) {
        if (value) {
            return this.formatFullDate(new Date(value - (new Date()).getTimezoneOffset() * 60000), format);
        }
        else {
            return "";
        }
    },
    formatFullDate: function(date, format) {
        if (!date) {
            return "";
        }
        if (!format) {
            format = "yyyy-mm-dd hh:mm:ss";
        }
        var year = date.getFullYear();
        var month = this.pad(date.getMonth() + 1, 2);
        var day = this.pad(date.getDate(), 2);
        var hour = this.pad(date.getHours(), 2);
        var minute = this.pad(date.getMinutes(), 2);
        var second = this.pad(date.getSeconds(), 2);
        return format.replace("yyyy", year).replace("mm", month).replace("dd", day).replace("hh", hour).replace("mm", minute).replace("ss", second);
    },
	/**
	 * @api
	 * Calculate the diffTime with the formatter.
	 */
	diffTime: function(endDateTimeStr, startDateTimeStr) {
		var diffTime = this.parseDateTimeStr(endDateTimeStr).getTime() - this.parseDateTimeStr(startDateTimeStr).getTime();
		return this.formatTime(diffTime);
	},
	formatTime: function(time) {
		if (isNaN(time) || time < 0) {
			return "--:--:--.---";
		}

		var ms = time % 1000;
		var s = (time / 1000) % 60;
		var h = parseInt((time / 1000) / 3600);
		var m = ((time / 1000) - s - h * 3600) / 60;
		return (h > 0 ? (this.pad(h, 2) + ":") : "") + this.pad(m, 2) + ":" + this.pad(s, 2) + (ms > 0 ? ("." + this.pad(ms, 3)) : "");
		// return this.pad(h, 2) + ":" + this.pad(m, 2) + ":" + this.pad(s, 2) + (shorten ? "" : ("." + this.pad(ms, 3)));
	},
	pad: function(value, length) {
		var rst = value.toString();
		if (rst.length < length) {
			for (var i = rst.length; i < length; i++) {
				rst = "0" + rst;
			}
		}
		return rst;
	},
	parseDateTimeStr: function(dateTimeStr) {
		var dateTimeReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})T(\d{1,2}):(\d{1,2}):(\d{1,2}).(\d{1,3})/; 
		var r = dateTimeStr.match(dateTimeReg);
		var date = new Date;
		date.setFullYear(r[1]);
		date.setMonth(r[3] - 1);
		date.setDate(r[4]);
		date.setHours(r[5]);
		date.setMinutes(r[6]);
		date.setSeconds(r[7]);
		date.setMilliseconds(r[8]);
		return date;
	},
	parseUTCDateTimeStr: function(utcDateTimeStr) {
		var dateTimeReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})T(\d{1,2}):(\d{1,2}):(\d{1,2}).(\d{1,3})/; 
		var r = utcDateTimeStr.match(dateTimeReg);
		var date = new Date;
		date.setUTCFullYear(r[1]);
		date.setUTCMonth(r[3] - 1);
		date.setUTCDate(r[4]);
		date.setUTCHours(r[5]);
		date.setUTCMinutes(r[6]);
		date.setUTCSeconds(r[7]);
		date.setUTCMilliseconds(r[8]);
		return date;
	},
	formatDisplayTime: function(timeStr) {
		// now use the english by default
		// @todo Consider to use the locale-specific rules.
		// [00:00, 24:00) - [00:00 AM - 12:00 PM - 23:00 PM]
		var hours = parseInt(timeStr.substring(0, 2));
		var appendix = (hours < 12) ? "AM" : "PM";
		var fixedHours = (hours <= 12) ? hours : (hours - 12);
		return this.pad(fixedHours, 2) + timeStr.substring(2, 5) + " " + appendix;
	},
	formatDisplayDate: function(dateStr) {
		var dateTimeReg = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})/; 
		var r = dateStr.match(dateTimeReg);
		var month = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
		return month[r[3] - 1] + r[4] + ", " + r[1];
	},
	formatDate: function(date, format) {
        if (date == null) {
            return
        }
        var fmt = format || 'yyyy-MM-dd';
		var o = {
			"M+": date.getMonth() + 1, 
			"d+": date.getDate(), 
			"h+": date.getHours(), 
			"m+": date.getMinutes(), 
			"s+": date.getSeconds(), 
			"q+": Math.floor((date.getMonth() + 3) / 3), 
			"S": this.pad(date.getMilliseconds(), 3) 
		};
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	},
	formatUTCDate: function(date, fmt, needZ) {
		var o = {
			"M+": date.getUTCMonth() + 1, 
			"d+": date.getUTCDate(), 
			"h+": date.getUTCHours(), 
			"m+": date.getMinutes(), 
			"s+": date.getSeconds(), 
			"q+": Math.floor((date.getMonth() + 3) / 3), 
			"S": this.pad(date.getMilliseconds(), 3) 
		};
		if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getUTCFullYear() + "").substr(4 - RegExp.$1.length));
		for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        if (needZ) {
            fmt = fmt.replace(" ", "T") + "Z";
        }
		return fmt;
	},
	offsetTimeZone: function(date, timeZoneOffset) {
		var originDate = date;
		if (typeof(date) === "string") {
			originDate = new Date(date);
		}
		var offsetDate = new Date(originDate.getTime() + timeZoneOffset * 3600000);
		return offsetDate;
	},
    getUTCTime: function(date) {
        if (date == null) {
            date = new Date();
        }
        return date.getTime() + date.getTimezoneOffset() * 60000;
    },
    getLocalDate: function(utcTime) {
        return new Date(utcTime - ((new Date).getTimezoneOffset() * 60000))
    },
    // ************************************************
    // NOTICE: ONLY FOR maidelong project
    // 
    // ************************************************
    unpad: function(value) {
        value = "" + value;
        while (value.charAt(0) == "0") {
            value = value.substr(1);
        }
        return value;
    },
    addDate: function(date, day) {
        var rDate = new Date(date);
        rDate.setDate(rDate.getDate() + day);
        return rDate;
    },
    addMonth: function(date, month) {
        var rDate = new Date(date);
        rDate.setMonth(rDate.getMonth() + month);
        return rDate;
    },
    // return the date without time info 
    getDate: function(date) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    },
    getFirstWeekStartDayOfYear: function(fullYear) {
        // firstDayOfWeek is 6 (Saturday)
        // keyDayOfWeek is 3 (Wednesday)
        // The first day of year
        var firstDayOfYear = new Date(fullYear, 0, 1, 0, 0, 0, 0);
        // The first day of week, and the week is the first week of year
        var firstWedDayOfYear = firstDayOfYear,
            day = firstDayOfYear.getDay();

        while (day != 3) {
            firstWedDayOfYear = this.addDate(firstWedDayOfYear, 1);
            day = firstWedDayOfYear.getDay();
        }

        var firstWeekStartDayOfYear = this.addDate(firstWedDayOfYear, -4);
        return firstWeekStartDayOfYear;
    },
    getWeekDayMappings: function(date) {
        var currentYear = date.getFullYear();
        var prevYear = currentYear - 1;
        var nextYear = currentYear + 1;

        var d1 = this.getFirstWeekStartDayOfYear(prevYear);
        var d2 = this.getFirstWeekStartDayOfYear(currentYear);
        var d3 = this.getFirstWeekStartDayOfYear(nextYear);

        var result = [];
        var num = 1;
        while (this.compare(d1, d2) < 0) {
            result.push({
                "weekNo": prevYear + this.pad(num, 2),
                "startDate": d1,
                "endDate": this.addDate(d1, 6)
            });
            d1 = this.addDate(d1, 7);
            num++;
        }

        num = 1;
        while (this.compare(d2, d3) < 0) {
            result.push({
                "weekNo": currentYear + this.pad(num, 2),
                "startDate": d2,
                "endDate": this.addDate(d2, 6)
            });
            d2 = this.addDate(d2, 7);
            num++;
        }

        result.push({
            "weekNo": nextYear + this.pad(1, 2),
            "startDate": d3,
            "endDate": this.addDate(d3, 6)
        });

        return result;
    },
    getWeekDate: function(date, fmt) {
        date = this.getDate(date);
        var weekDayMappings = this.getWeekDayMappings(date);
        for (var i = 0; i < weekDayMappings.length; i++) {
            var mapping = weekDayMappings[i],
                weekNo = mapping.weekNo,
                startDate = mapping.startDate,
                endDate = mapping.endDate;

            if (this.compare(date, startDate) >= 0 && this.compare(date, endDate) <= 0) {
                return {
                    "weekNo": weekNo,
                    "startDate": this.formatDate(startDate, fmt),
                    "endDate": this.formatDate(endDate, fmt)
                }
            }
        }
    },
    getFirstWeekStartDayOfMonth: function(date) {
        // The first day of date month
        var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0);
        // The first day of week, and the week is the first week of year
        var day = firstDayOfMonth.getDay();

        while (day != 3) {
            firstDayOfMonth = this.addDate(firstDayOfMonth, 1);
            day = firstDayOfMonth.getDay();
        }

        var firstWeekStartDayOfMonth = this.addDate(firstDayOfMonth, -4);
        return firstWeekStartDayOfMonth;
    },
    getMonthDate: function(date, fmt) {
        date = this.getDate(date);
        var curMonthDate =  date;
        var nextMonthDate = this.addMonth(date, 1);

        var startDate = this.getFirstWeekStartDayOfMonth(curMonthDate);
        var endDate = this.addDate(this.getFirstWeekStartDayOfMonth(nextMonthDate), -1);

        if (this.compare(date, startDate) < 0) {
            curMonthDate = this.addMonth(date, -1);
            nextMonthDate = date;
            startDate = this.getFirstWeekStartDayOfMonth(curMonthDate);
            endDate = this.addDate(this.getFirstWeekStartDayOfMonth(nextMonthDate), -1);
        }
        else if (this.compare(date, endDate) > 0) {
            curMonthDate = this.addMonth(date, 1);
            nextMonthDate = this.addMonth(date, 2);
            startDate = this.getFirstWeekStartDayOfMonth(curMonthDate);
            endDate = this.addDate(this.getFirstWeekStartDayOfMonth(nextMonthDate), -1);
        }
        var startDate2 = startDate;
        var monthDays = {};
        var monthNo;
        while (this.compare(startDate2, endDate) <= 0) {
            monthNo = startDate2.getFullYear() + this.pad(startDate2.getMonth()+1, 2);
            if (!monthDays[monthNo]) {
                monthDays[monthNo] = 1;
            }
            else {
                monthDays[monthNo] = monthDays[monthNo] + 1;
            }
            startDate2 = this.addDate(startDate2, 1);
        }

        var days = 0;
        for (var p in monthDays) {
            if (monthDays[p] > days) {
                monthNo = p;
                days = monthDays[p];
            }
        }

        return {
            "monthNo": monthNo,
            "startDate": this.formatDate(startDate, fmt),
            "endDate": this.formatDate(endDate, fmt)
        };
    },
    compare: function(d1, d2) {
        if (d1.getTime() < d2.getTime()) {
            return -1;
        }
        else if (d1.getTime() == d2.getTime()) {
            return 0;
        }
        else if (d1.getTime() > d2.getTime()) {
            return 1;
        }
    }
}

/**
 * The static implementation approach
 * @return The static method.
 */
var instance;
if (!instance) {
	instance = new tbs_util_DateTimeFunc;
}

module.exports = instance;